export default __webpack_public_path__ + "static/logo-w-d827ac7d7aa43960287465f4a4fd9793.svg";